export const getQueryParam = (param: string, searchString?: string) => new URLSearchParams(searchString || window.location.search).get(param);

